import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import config from '../config'

export const AuthContext = React.createContext({
  token: null,
  handleLogin: () => {},
  handleLogout: () => {}
})

const AuthContextProvider = props => {
  const [token, setToken] = useState(null)

  useEffect(() => {
    const storageToken = localStorage.getItem('JWT')
    if (storageToken) {
      setToken(storageToken)
    }
  }, [])

  const handleLogin = (authToken) => {
    // const authToken = config.api.token
    localStorage.setItem('JWT', authToken)
    config.api.token = authToken
    setToken(authToken)
  }

  const handleLogout = () => {
    localStorage.removeItem('JWT')
    config.api.token = ''
    setToken(null)
  }

  return (
    <AuthContext.Provider value={{
      token: token,
      handleLogin: handleLogin,
      handleLogout: handleLogout
    }}
    >
      {props.children}
    </AuthContext.Provider>
  )
}

export default AuthContextProvider

AuthContextProvider.propTypes = {
  children: PropTypes.node
}
